import React from 'react';
import {
  PopoverAuto,
  PopoverTitle,
  PopoverContent, Button,
  Container, Row, Col
} from './reactstrap/lib';
import InlineSVG from 'react-svg-inline';
import calendar from '../../imgs/calendar.svg';

/*date */

import moment from 'moment';
import "moment/locale/ru";
import MomentLocaleUtils from 'react-day-picker/moment';

import DayPicker, {DateUtils} from "react-day-picker";

/*
 * @var from
 * @var to
 * function:setDate(range) set @vars to state
 * */
export default class SelectDate extends React.Component {
  constructor(props) {
    super(props);
    let {from, to} = this.props;
    this.state = {
      from,
      to,
      selectedDays: [],
      popoverOpen: false,
    };
    this.handleDayClick = this.handleDayClick.bind(this);
    this.toggle = this.toggle.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if(!this.state.popoverOpen){
      let {from, to} = nextProps;
      this.state = {
        from,
        to
      };
    }
  }
  toggle() {
    let { from, to, popoverOpen} = this.state;
    this.setState({
      selectedDays: [],
      popoverOpen: !popoverOpen
    });
    if(popoverOpen) this.props.setDate({from, to});
  }

  handleDayClick(e, day, {selected}) {
    let {selectedDays, from, to} = this.state;
    selectedDays.push(day);
    if (selectedDays.length == 1) from = selectedDays[0], to = selectedDays[0];
    if (selectedDays.length == 2) {
      selectedDays.sort(function(a,b){
        return a - b;
      });
      from = selectedDays[0], to = selectedDays[1];

      this.setState({selectedDays, from, to}, () => this.toggle());
    }
    else {
      this.setState({selectedDays, from, to});
    }
  }

  render() {
    let {from, to} = this.state;

    return (
      <div>
        {this.state.popoverOpen && <div onClick={this.toggle} className="modal-backdrop custom-backdrop"></div>}

        <button id="Popover1" onClick={this.toggle} className="form-control">
          {!from && !to && '00.00.0000 - 00.00.0000'}
          {from && !to && moment(from).format('ll') + '- 00.00.0000'}
          {from && to && <p> {moment(from).format('ll')} - {moment(to).format('ll')}<InlineSVG svg={calendar}/></p>
          }
        </button>
        <PopoverAuto className="popover-datepicker" placement={this.props.placement} isOpen={this.state.popoverOpen}
                     target="Popover1">
          <PopoverContent>
            <DayPicker
              numberOfMonths={2}
              initialMonth={from}
              localeUtils={MomentLocaleUtils} locale="ru"
              selectedDays={day => DateUtils.isDayInRange(day, {from, to})}
              onDayClick={this.handleDayClick}
            />
          </PopoverContent>
        </PopoverAuto>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/SelectDate.jsx
 **/